import { Getters } from 'vuex-smart-module';
import { EventHistoryState } from './state';

export default class EventHistoryGetters extends Getters<EventHistoryState> {}
